// extracted by mini-css-extract-plugin
export var container = "_4s-0";
export var fallback = "_4s-5";
export var fallbackIcon = "_4s-6";
export var hidden = "_4s-2";
export var image = "_4s-3";
export var loaded = "_4s-4";
export var placeholder = "_4s-1";